import {
  parseUnparseEchoPredicate,
  parseUnparseEchoPredicateNumber,
  parseUnparseNullPredicate,
  PredicateParserType,
} from "./predicates";
import type { AnswerFormatType, AnswerModuleType } from "./types";

type AnswerModuleRegistryEntry = {
  [T in AnswerFormatType]: {
    answerModuleType: T;
    label: string;
    examplePredicate: string | null;
  } & PredicateParserType<any>;
}[AnswerFormatType];

type AnswerModuleRegistry = Record<AnswerModuleType, AnswerModuleRegistryEntry>;

export const ANSWER_MODULE_REGISTRY = {
  DEV_always_false: {
    answerModuleType: "boolean",
    label: "Always False",
    examplePredicate: null,
    ...parseUnparseNullPredicate,
  },
  DEV_always_true: {
    answerModuleType: "boolean",
    label: "Always True",
    examplePredicate: null,
    ...parseUnparseNullPredicate,
  },
  DEV_echo_predicate: {
    answerModuleType: "free_text",
    label: "Echo Predicate",
    examplePredicate: JSON.stringify({ answer: "This is the answer" }),
    ...parseUnparseEchoPredicate,
  },
  DEV_echo_predicate_number: {
    answerModuleType: "numeric",
    label: "Echo Predicate Number",
    examplePredicate: JSON.stringify({ answer: 42 }),
    ...parseUnparseEchoPredicateNumber,
  },
  DEV_select_first: {
    answerModuleType: "selected_option",
    label: "Select First",
    examplePredicate: null,
    ...parseUnparseNullPredicate,
  },
  DEV_select_all: {
    answerModuleType: "multi_select_options",
    label: "Select All",
    examplePredicate: null,
    ...parseUnparseNullPredicate,
  },
  DEV_select_none: {
    answerModuleType: "multi_select_options",
    label: "Select None",
    examplePredicate: null,
    ...parseUnparseNullPredicate,
  },
} satisfies AnswerModuleRegistry;
